module.exports = __webpack_public_path__ + "static/media/ventures.3495bb57.jpg";